module.exports = __webpack_public_path__ + "static/media/sharkOpenMouth.6d906e51.svg";